import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "mimeTypeCheck"
})
export class MimeTypeCheckPipe implements PipeTransform {
    public transform(fileType: string | null | undefined, mimeTypeArray: string[]): boolean {
        if (!fileType || !mimeTypeArray) {
            return false;
        }
        return mimeTypeArray.includes(fileType);
    }
}
